export type SectionType = 'input' | 'view' | 'run-solver' | 'run-history' | 'run-output' | 'chart'

export type TableSection = {
  id: string
  label: string
  type?: SectionType  // defaults to 'input'
  runId?: string      // only set for 'run-output' type
  scenarioId?: string // set when viewing scenario-scoped data
}

export type SectionGroup = {
  id: string
  label: string
  items: TableSection[]
}

export const SECTION_GROUPS: SectionGroup[] = [
  {
    id: 'combined',
    label: 'Combined Views',
    items: [
      {
        id: 'product-location-period',
        label: 'Product / Location / Period',
        type: 'view',
      },
      {
        id: 'supplier-location-product-period',
        label: 'Supplier / Location / Product / Period',
        type: 'view',
      },
      {
        id: 'supplier-resource-period',
        label: 'Supplier / Resource / Period',
        type: 'view',
      },
    ],
  },
  {
    id: 'charts',
    label: 'Output Charts',
    items: [
      { id: 'output-dashboard', label: 'Output Dashboard', type: 'chart' },
    ],
  },
]

export const SOLVER_SECTIONS: TableSection[] = [
  { id: 'run-solver', label: 'Run Solver', type: 'run-solver' },
  { id: 'run-history', label: 'Run History', type: 'run-history' },
]

export const DEFAULT_SECTION: TableSection = SECTION_GROUPS[0]!.items[0]!

export const findSection = (id: string): TableSection | undefined =>
  [...SECTION_GROUPS.flatMap((g) => g.items), ...SOLVER_SECTIONS].find(
    (item) => item.id === id,
  )
